<template>

    <v-row class="fill-height">
        <v-col>

            <v-card>

                <v-card-title>
                    <v-icon left>mdi-account-box</v-icon>
                    Perfil
                    <v-spacer></v-spacer>

                    <v-btn outlined
                           :class="`${profile.active? 'btn-inactive': 'btn-active'} mx-2`"
                           @click="dialogActiveInactive=true">

                        <span v-if="profile.active"><v-icon
                            left>mdi-diameter-variant</v-icon>Inativar no Aplicativo</span>
                        <span v-else><v-icon left>mdi-checkbox-marked-circle-outline</v-icon>Ativar no Aplicativo</span>

                        <!-- <v-icon left>mdi-pencil</v-icon>
                         <span v-if="profile.active">Inativar no Aplicativo</span><span v-else>Ativar no Aplicativo</span>-->
                    </v-btn>

                    <v-btn
                        color="#3A33E8"
                        dark
                        :to="{ name: 'editProfile' }"
                    >
                        <v-icon left>mdi-pencil</v-icon>
                        Editar
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col md="2" sm="12">
                            <v-card justify="center" align="center">
                                <input v-show="false" ref="inputUpload" type="file"
                                       v-on:change="previewImage">
                                <!--                                        <v-file-input-->
                                <!--                                            v-show="false" ref="inputUpload"-->
                                <!--                                            v-model="updateLogo"-->
                                <!--                                            accept="image/png, image/jpeg, image/bmp"-->
                                <!--                                            placeholder="Escolha uma imagem."-->
                                <!--                                            prepend-inner-icon="mdi-camera"-->
                                <!--                                            prepend-icon=""-->
                                <!--                                            label="Imagem"-->
                                <!--                                            outlined-->
                                <!--                                            @change="previewImage"-->
                                <!--                                        ></v-file-input>-->
                                <v-btn
                                    color="purple"
                                    absolute
                                    bottom
                                    right
                                    fab
                                    outlined
                                    x-small @click="$refs.inputUpload.click()">
                                    <v-icon>mdi-image-edit</v-icon>
                                </v-btn>
                                <v-img v-bind:src="logo"
                                       max-height="256"
                                       max-width="256"
                                       :aspect-ratio="1"
                                       contain
                                >
                                    <v-card-title class="align-end text-right fill-height" primary-title>
                                        <v-spacer></v-spacer>
                                        <!--                                                <v-file-input-->
                                        <!--                                                    hide-input-->
                                        <!--                                                    filled-->
                                        <!--                                                    truncate-length="1"-->
                                        <!--                                                    prepend-icon="mdi-camera"-->
                                        <!--                                                    -->
                                        <!--                                                >-->

                                        <!--                                                </v-file-input>-->


                                        <!--                                                <v-btn fab x-small style="z-index: 9999" v-on:click.stop="action2"><v-icon>mdi-image-edit</v-icon></v-btn>-->
                                        <!--                                                <v-btn-->
                                        <!--                                                    icon-->
                                        <!--                                                    outlined-->
                                        <!--                                                    dark-->
                                        <!--                                                    color="deep-orange"-->
                                        <!--                                                    style="z-index: 9999"-->
                                        <!--                                                >-->
                                        <!--                                                    <v-icon>mdi-thumb-up</v-icon>-->
                                        <!--                                                </v-btn>-->
                                    </v-card-title>
                                </v-img>
                            </v-card>
                        </v-col>
                        <!--                                <v-col md="3">-->
                        <!--                                    <v-card-->
                        <!--                                        :color="active ? 'primary' : undefined"-->
                        <!--                                        class="mx-auto"-->
                        <!--                                        flat-->
                        <!--                                        rounded="xl"-->

                        <!--                                        @click="active = true"-->
                        <!--                                    >-->
                        <!--                                        <v-img-->
                        <!--                                            :aspect-ratio="16/9"-->

                        <!--                                            v-bind:src="logo"-->
                        <!--                                        ></v-img>-->
                        <!--                                        <v-card-title class="align-end fill-height" primary-title>-->
                        <!--                                            <v-btn class="blue" style="z-index: 9999" v-on:click.stop="action2">-->
                        <!--                                                clickable-->
                        <!--                                            </v-btn>-->
                        <!--                                        </v-card-title>-->
                        <!--                                    </v-card>-->
                        <!--                                </v-col>-->

                        <v-col md="10" sm="12">
                            <v-card style="border-left: solid 10px #3D1159 !important;">
                                <v-card-title>

                                </v-card-title>

                                <v-card-text class="text-data-visualization">
                                    <v-row>
                                        <v-col md="10">
                                            <div class="mb-2 ">
                                                <strong>
                                                    <v-icon>mdi-card-account-details-outline</v-icon>
                                                    CNPJ:
                                                </strong>
                                                {{ profile.cnpj }}
                                            </div>
                                        </v-col>

                                    </v-row>
                                    <v-row>
                                        <v-col md="10">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-office-building</v-icon>
                                                    Nome da Empresa:
                                                </strong>
                                                {{ profile.companyName }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="10">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-office-building</v-icon>
                                                    Nome Fantasia:
                                                </strong>
                                                {{ profile.fantasyName }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="6" xl="6" sm="6" xs="12">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-phone</v-icon>
                                                    Telefone:
                                                </strong>
                                                {{ profile.phone }}
                                            </div>
                                        </v-col>
                                        <v-col md="6" xl="6" sm="6" xs="12">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-at</v-icon>
                                                    E-mail:
                                                </strong>
                                                {{ profile.email }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="12" sm="12" xs="12">
                                            <v-icon>mdi-format-align-justify</v-icon>
                                            <b>Descrição:</b> {{ profile.desc }}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col lg="4" md="3">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-map-marker</v-icon>
                                                    CEP:
                                                </strong>
                                                {{ profile.zipcode }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="10">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-map-marker</v-icon>
                                                    Endereço:
                                                </strong>
                                                {{ profile.street }}
                                                ,{{ profile.number }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col md="6">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-map-marker</v-icon>
                                                    Complemento:
                                                </strong>
                                                {{ profile.addressComplement }}
                                            </div>
                                        </v-col>
                                        <v-col md="4">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-map-marker</v-icon>
                                                    Bairro:
                                                </strong>
                                                {{ profile.district }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col lg="6" md="6">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-map-marker</v-icon>
                                                    Cidade:
                                                </strong>{{ profile.city }}
                                            </div>
                                        </v-col>
                                        <v-col lg="4" md="4">
                                            <div class="mb-2">
                                                <strong>
                                                    <v-icon>mdi-map-marker</v-icon>
                                                    Estado:
                                                </strong>
                                                {{ profile.state }}
                                            </div>
                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>


                            <!--
                                <v-row>
                                    <v-col md="10">
                                        <h4>Endereço:</h4>
                                    </v-col>
                                </v-row>
                            -->


                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col md="4">
                            <v-card tile
                                    style="border-left: solid 10px #3D1159 !important; border-radius: 5px !important; color:#3A33E8;">
                                <v-card-title>
                                    Dias de Funcionamento

                                </v-card-title>

                                <v-card-text>
                                    <v-list dense>
                                        <v-list-item v-for="(weekday, k) in profile.weekDays"
                                                     :key="k + 'w'">
                                            {{
                                                `${weekday.name}: Das ${weekday.startTime} às ${weekday.endTime}`
                                            }}
                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col md="4">
                            <v-card tile
                                    style="border-left: solid 10px #3D1159 !important; border-radius: 5px !important; color:#3A33E8;">
                                <v-card-title>
                                    Dias Fechados
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="btn-new"
                                        small
                                        @click="dialogDayOff=true"
                                    >
                                        <v-icon left>mdi-plus</v-icon>
                                        Adicionar
                                    </v-btn>
                                </v-card-title>

                                <v-card-text>
                                    <v-list dense>
                                        <v-list-item v-for="(dayOff, index) in profile.dayOffs"
                                                     :key="index + 'd'" class="ma-0 pa-0">

                                            {{ dayOff.startDate | formatDate2 }} às
                                            {{ dayOff.endDate | formatDate2 }}
                                            <v-spacer></v-spacer>
                                            <v-btn class="btn-del" icon @click="preDeleteDayOff(dayOff.id, index) ">
                                                <v-icon>mdi-minus-circle-outline</v-icon>
                                            </v-btn>

                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col md="4">
                            <v-card tile
                                    style="border-left: solid 10px #3D1159 !important; border-radius: 5px !important; color:#3A33E8;">
                                <v-card-title>
                                    Redes Sociais
                                    <v-spacer></v-spacer>

                                    <v-btn
                                        color="#3D1159"
                                        dark
                                        small
                                        @click="addSocial()"
                                        v-show="socialsOk"
                                    >
                                        <v-icon left>mdi-plus</v-icon>
                                        Adicionar
                                    </v-btn>
                                </v-card-title>

                                <v-card-text>
                                    <v-list
                                        dense
                                    >
                                        <v-list-item v-for="(social, k) in bs_socials"
                                                     :key="k + 's'">
                                            <a :href="social.url" target="_blank"
                                               class="text-decoration-none">
                                                {{ social.desc }}
                                            </a>
                                            <v-spacer></v-spacer>
                                            <v-btn icon color="#3A33E8" small class="mr-2" @click="editSocial(social)">
                                                <v-icon>mdi-pencil-circle-outline</v-icon>
                                            </v-btn>
                                            <v-btn icon color="#FF3816" small @click="removeSocialDialog(social)">
                                                <v-icon>mdi-minus-circle-outline</v-icon>
                                            </v-btn>
                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>


            <v-dialog
                v-model="dialogSocial"
                persistent
                max-width="700px"
            >
                <v-card>
                    <v-form ref="formSocial" v-model="formIsValid"
                            v-on:submit.prevent="submitSocial()">
                        <v-card-title>
                            <span class="text-h5">Redes sociais</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        md="4"
                                    >
                                        <v-select
                                            v-model="social.socialID"
                                            outlined
                                            :items="socials"
                                            item-text="desc"
                                            item-value="id"
                                            label="Rede Social"
                                            placeholder="Selecione a rede social"
                                            :rules="textRules"
                                            :disabled="socialEdit"
                                            @change="selectSocial()"
                                        ></v-select>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="8"
                                        md="8"
                                    >
                                        <v-text-field
                                            v-model="social.url"
                                            outlined
                                            label="Endereço Completo"
                                            :placeholder="social.hintText"
                                            :rules="textRules"
                                            required
                                            :hint="social.hintText"
                                            persistent-hint
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                color="#3D1159"
                                @click="closeSocial()"
                            >
                                Fechar
                            </v-btn>
                            <v-btn
                                color="success"
                                dark
                                type="submit"
                            >
                                <v-icon left>mdi-content-save</v-icon>
                                Salvar
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="dialogSocialRemove"
                persistent
                max-width="290"
            >
                <v-card>
                    <v-card-title class="text-h5">
                        Remover rede social
                    </v-card-title>
                    <v-card-text>Tem certeza que deseja remover?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="#FF3816"
                            outlined
                            @click="dialogSocialRemove = false; social.socialID = null"
                        >
                            Cancelar
                        </v-btn>
                        <v-btn
                            color="success"
                            outlined
                            @click="removeSocial"
                        >
                            Confirmar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="dialogDayOff"
                persistent
                max-width="600px"
            >
                <v-card>
                    <v-form ref="formProfileDayOff"
                            v-model="formIsValid"
                            v-on:submit.prevent="submitDayOff()">
                        <v-card-title>
                            <span class="text-h5">Dia Fechado </span>
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        v-model="profileDayOff.startDate"
                                        outlined
                                        :rules="dateTimeRule"
                                        placeholder="DD/MM/AAAA HH:MM"
                                        v-mask="['##/##/#### ##:##']"
                                        label="Data e Hora de Início"
                                    />
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        v-model="profileDayOff.endDate"
                                        outlined
                                        :rules="dateTimeRule"
                                        placeholder="DD/MM/AAAA HH:MM"
                                        v-mask="['##/##/#### ##:##']"
                                        label="Data e Hora de Término"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="#FF3816"
                                dark
                                @click="dialogDayOff = false"
                            >
                                <v-icon>mdi-close</v-icon>
                                Cancelar
                            </v-btn>
                            <v-btn
                                color="success"
                                type="submit"
                            >
                                <v-icon>mdi-content-save</v-icon>
                                Salvar
                            </v-btn>
                        </v-card-actions>

                    </v-form>
                </v-card>
            </v-dialog>
        </v-col>

        <confirm-dialog
            :dialog="dialogActiveInactive"
            :title="`${profile.active? 'Inativar ': 'Ativar '} no Aplicativo`"
            body="Tem certeza que deseja realizar essa ação?"
            @dialog-event="inactiveActive">
        </confirm-dialog>

        <confirm-dialog
            :dialog="dialogDeleteProfileDayOff"
            :title="`Remover dia fechado`"
            :body="`Tem certeza que deseja remover este período fechado ?`"
            @dialog-event="deleteProfileDayOff">
        </confirm-dialog>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import {mask} from "vue-the-mask";
import ConfirmDialog from '@/components/ConfirmDialog'

import store from "@/store";

import API_URL from "@/common/config";

import {
    PROFILE_GET,
    PROFILE_DAYS_OFF_GET,
    PROFILE_LOGO_GET,
    PROFILE_ADD_DAY_OFF,
    PROFILE_DELETE_DAY_OFF, PROFILE_INACTIVE, PROFILE_ACTIVE
} from "@/store/actions/profile.type";
import {
    PROFILE_REMOVE_DAY_OFF,
    PROFILE_RESET_STATE,
    SET_LOGO, SET_PROFILE_ACTIVE, SET_PROFILE_DAY_OFF
} from "@/store/mutations/profile.type";
import {ProfileService} from "@/common/api/profile.service";
import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";
import {
    BS_SOCIALS_GET,
    SOCIAL_CREATE,
    SOCIAL_DELETE,
    SOCIAL_EDIT,
    SOCIALS_GET
} from "@/store/actions/social.type";
import {SET_SOCIAL, SET_SOCIAL_EDIT, SET_SOCIAL_HINT} from "@/store/mutations/social.type";
import {resizeImage} from "@/common/image.service";

export default {
    name: "Profile",
    directives: {mask},
    components: {ConfirmDialog},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await this.$store.commit(PROFILE_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.commit(PROFILE_RESET_STATE);
        await store.dispatch(PROFILE_GET);
        await store.dispatch(PROFILE_DAYS_OFF_GET);
        await store.dispatch(SOCIALS_GET);
        await store.dispatch(BS_SOCIALS_GET);

        return next();
    },
    data: () => ({
        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        formIsValid: false,
        active: false,
        apiUrl: API_URL,
        dialogSocial: false,
        dialogSocialRemove: false,
        dialogDeleteProfileDayOff: false,
        dialogDayOff: false,
        socialEdit: false,
        updateLogo: null,
        dayOffID: null,
        dayOffIndex: null,

        dialogActiveInactive: false,

        dateTimeRule: [
            date => {
                if (!date) return true;
                const pattern = /^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d\d\d\d (20|21|22|23|[0-1]?\d):[0-5]?\d$/
                return pattern.test(date) || "Informe uma data válida."
            }
        ]
    }),
    methods: {
        addSocial() {
            this.dialogSocial = true
            this.$store.commit(SET_SOCIAL_EDIT, false)
        },
        selectSocial() {
            this.$store.commit(SET_SOCIAL_HINT, this.social.socialID)
        },
        closeSocial() {
            this.$refs.formSocial.resetValidation();
            this.socialEdit = false;
            this.dialogSocial = false;
            this.social.socialID = null;
            this.social.url = "";
        },
        editSocial(social) {

            this.$store.commit(SET_SOCIAL, {socialID: social.socialID, url: social.url, hintText: ""})
            this.$store.commit(SET_SOCIAL_HINT, social.socialID)
            this.$store.commit(SET_SOCIAL_EDIT, true)

            this.dialogSocial = true;
            this.socialEdit = true
        },
        removeSocialDialog(social) {
            this.dialogSocialRemove = true
            this.social.socialID = social.socialID
        },
        async submitSocial() {
            if (this.$refs.formSocial.validate()) {
                this.$store.commit(CHANGE_PROGRESS, true);

                let action = this.socialEdit ? SOCIAL_EDIT : SOCIAL_CREATE;

                await this.$store
                    .dispatch(action, {socialID: this.social.socialID, url: this.social.url})
                    .then(async () => {
                        this.$store.commit(CHANGE_PROGRESS, false)
                        this.$store.commit(SET_SOCIAL_EDIT, true)

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                        await this.$store.dispatch(BS_SOCIALS_GET);
                        await this.$store.dispatch(SOCIALS_GET);
                    })
                    .catch(({response}) => {
                        this.$store.commit(CHANGE_PROGRESS, false);
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar Rede Social.";
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro ao salvar Rede Social: " +
                                response.data.message;
                        }
                    });

                this.$refs.formSocial.resetValidation();
                this.social.socialID = null;
                this.social.url = "";
                this.dialogSocial = false;
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },
        async removeSocial() {
            await this.$store
                .dispatch(SOCIAL_DELETE, this.social.socialID)
                .then(async () => {
                    this.$store.commit(CHANGE_PROGRESS, false);

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Removido com sucesso";

                    await this.$store.dispatch(BS_SOCIALS_GET);
                    await this.$store.dispatch(SOCIALS_GET);
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao remover Rede Social.";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro ao remover Rede Social: " +
                            response.data.message;
                    }
                });
            this.dialogSocialRemove = false;
            this.social.socialID = null;
        },
        submitDayOff() {
            this.dialogDayOff = false
            this.$store.commit(CHANGE_PROGRESS, true)

            this.$store
                .dispatch(PROFILE_ADD_DAY_OFF)
                .then(async () => {
                    this.$refs.formProfileDayOff.resetValidation();
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Adicionado com sucesso";

                    await this.$store.dispatch(PROFILE_DAYS_OFF_GET)
                    this.$store.commit(SET_PROFILE_DAY_OFF, {id: 0, startDate: null, endDate: null})

                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Adicionar.";

                    if (typeof response.data !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        preDeleteDayOff(id, index) {
            this.dayOffID = id;
            this.dayOffIndex = index;

            this.dialogDeleteProfileDayOff = true
        },
        deleteProfileDayOff(status) {
            this.dialogDeleteProfileDayOff = false
            if (!status) {
                return
            }

            this.$store.commit(CHANGE_PROGRESS, true)
            this.$store
                .dispatch(PROFILE_DELETE_DAY_OFF, this.dayOffID)
                .then(() => {

                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Excluído com sucesso";

                    this.$store.commit(PROFILE_REMOVE_DAY_OFF, this.dayOffIndex)
                    this.dayOffID = null
                    this.dayOffIndex = null
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao excluir.";

                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },
        async previewImage(img) {
            if (img.target.files[0]) {
                this.$store.commit(CHANGE_PROGRESS, true)


                resizeImage({
                    file: img.target.files[0],
                    maxWidth: 256,
                    maxHeight: 256
                }).then(async (imageFile) => {

                    await ProfileService.save_logo(imageFile).then(() => {

                        this.$store.commit(CHANGE_PROGRESS, false)

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Salvo com sucesso";

                    })
                        .catch(({response}) => {
                            this.$store.commit(CHANGE_PROGRESS, false)

                            this.snackbar.snackbar = true;
                            this.snackbar.color = "error";
                            this.snackbar.text = "Erro ao salvar imagem.";

                            if (typeof response.data.message !== "undefined") {
                                this.snackbar.text =
                                    "Erro ao salvar imagem: " +
                                    response.data.message;
                            }
                        });
                    this.$store.commit(SET_LOGO, URL.createObjectURL(img.target.files[0]));
                }).catch(function (err) {
                    console.log(err)
                    this.$store.commit(CHANGE_PROGRESS, false)

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar.";

                });
            }
        },
        inactiveActive(status) {
            this.dialogActiveInactive = false
            if (!status) {
                return
            }
            let action = this.profile.active ? PROFILE_INACTIVE : PROFILE_ACTIVE;
            this.$store.commit(CHANGE_PROGRESS, true)

            this.$store
                .dispatch(action, this.profile.id)
                .then(() => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Alterado com sucesso";
                    this.$store.commit(SET_PROFILE_ACTIVE, !this.profile.active)
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao alterar.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        }
    },
    mounted() {
        this.$store.dispatch(PROFILE_LOGO_GET);
    },
    computed: {
        ...mapGetters(["profile", "logo", "snackbar", "bs_socials", "socials", "social", "profileDayOff", "socialsOk"])
    }
};
</script>

<style scoped>
.gridSys {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}

.grid-2-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
}
</style>
